
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"paymentTypesFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTypesConfig"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alt36"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"check"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditCardAtDoor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payOnlineChase"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payOnlineHypur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payOnlineMerrco"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"payOnlineMoneris"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creditCardByPhone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"debit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dutchiePay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rethinkPay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cash"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"linx"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canPay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paytender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aeropay"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"kioskOrderingSettingsFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KioskOrderingSettings"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fullNameOnly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phoneRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"notesField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"directedOrders"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideEmailField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hidePhoneField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showBirthdateField"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"anonymousCheckout"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"kioskInstructions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"paymentTypesFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"timeout"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"duration"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"notificationSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"push"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"autoConfirmSettings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autoClose"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":753}};
    doc.loc.source = {"body":"# region: payment-types-fragment.gql\nfragment paymentTypesFragment on PaymentTypesConfig {\n  alt36\n  check\n  creditCardAtDoor\n  payOnlineChase\n  payOnlineHypur\n  payOnlineMerrco\n  payOnlineMoneris\n  creditCardByPhone\n  debit\n  dutchiePay\n  rethinkPay\n  cash\n  linx\n  canPay\n  paytender\n  aeropay\n}\n\n# endregion\n\nfragment kioskOrderingSettingsFragment on KioskOrderingSettings {\n  enabled\n  fullNameOnly\n  phoneRequired\n  notesField\n  directedOrders\n  hideEmailField\n  hidePhoneField\n  showBirthdateField\n  anonymousCheckout\n  kioskInstructions\n  type\n  paymentTypes {\n    ...paymentTypesFragment\n  }\n  timeout {\n    enabled\n    duration\n  }\n  notificationSettings {\n    sms\n    email\n    push\n  }\n  autoConfirmSettings {\n    enabled\n    autoClose\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["paymentTypesFragment"] = oneQuery(doc, "paymentTypesFragment");
        
        module.exports["kioskOrderingSettingsFragment"] = oneQuery(doc, "kioskOrderingSettingsFragment");
        
